"use strict";

/* https://github.com/matthewhudson/current-device */
import Viewports from '../fsUtils/Viewports.js'

class FsBeacon {
    EpgTracking(props) {
        return new EpgTracking(props);
    }

    DoubleClickFloodlightTracking() {
        return new DoubleClickFloodlightTracking({});
    }
}

/*
*   Note: props will be converted to escaped query string.
*   USAGE EXAMPLE:
*        let props = {
            postType: this.props.postType,
            content: this.props.state
        };
        FsBeacon.EpgTracking(props).send();
* */

class BaseTracking {
    constructor(props) {
        this.props = props || {};
        this.delayInMilliseconds = 500;
    }

    send(url, props) {
        if (props) {
            let queryString = jsonToQueryString(props);
            url += "?" + queryString;
        }
        goFetch(url, this.delayInMilliseconds);
    }
}

class EpgTracking extends BaseTracking {
    constructor(props) {
        super(props);
        let viewPorts = new Viewports();

        this.props.url = window.location.href;
        this.props.deviceType = viewPorts.isMobile ? 'Mobile' : 'Desktop';
        this.props.campaign = "fsgo_epg";
        this.url = "/conv-epg";
    }

    fire() {
        super.send(this.url, this.props);
    }
}

class DoubleClickFloodlightTracking extends BaseTracking {
    /*
        Start of DoubleClick Floodlight Tag: Please do not remove
        Activity name of this tag: FoxSports_Install-Open_Counter
        URL of the webpage where the tag is expected to be placed: https://www.foxsports.com/
        This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
        Creation Date: 05/08/2018
    */
    constructor(props) {
        super(props);
    }

    fire() {
        this.floodlightTracking();
        this.GTMTracking();
    }

    floodlightTracking() {
        /* We need to use an iframe based on Floodlight tracking documentation. */
        let axel = Math.random() + '';
        let a = axel * 10000000000000;
        this.url = 'https://5805365.fls.doubleclick.net/activityi;src=5805365;type=alluniqu;cat=foxsp0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?';

        var iframe = document.createElement('iframe');
        iframe.src = this.url;
        iframe.width = 1;
        iframe.height = 1;
        iframe.setAttribute('style', 'display: none');
        /* Introducing a slight delay.  There was an issue with Safari on iOS with immediate firing. */
        setTimeout(function () {
            document.querySelector('body').appendChild(iframe);
        }, this.delayInMilliseconds);
    }

    GTMTracking() {
        /*
        Event snippet for FoxSports_Install-Open_Counter on https://www.foxsports.com/: Please do not remove.
        Place this snippet on pages with events you’re tracking.
        Creation date: 07/16/2018
        */
        setTimeout(function () {
            gtag('event', 'conversion', {
                'allow_custom_scripts': true,
                'send_to': 'DC-8763171/insta0/foxsp0+standard'
            });
        }, this.delayInMilliseconds);
    }
}

function jsonToQueryString(json) {
    return Object.keys(json).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    }).join('&');
}

function goFetch(url, delay) {
    setTimeout(function () {
        fetch(url, {
            mode: 'no-cors'
        }).then(function (response) { /* intentionally left blank for future implementation. */
        });
    }, delay);
}

export default FsBeacon;



// WEBPACK FOOTER //
// ./assets/components/fs-beacon/FsBeacon.js